import { render } from "./ArticleBlock.vue?vue&type=template&id=7beb57d7&scoped=true&bindings={\"article\":\"props\",\"index\":\"props\",\"ArticleSummary\":\"setup\",\"ArticleUrl\":\"setup\",\"ArticleDate\":\"setup\"}"
import script from "./ArticleBlock.vue?vue&type=script&lang=js"
export * from "./ArticleBlock.vue?vue&type=script&lang=js"

import "./ArticleBlock.vue?vue&type=style&index=0&id=7beb57d7&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-7beb57d7"

export default script